import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';

const notify: AppRouteModule = {
  path: RouteEnum.NOTIFY,
  name: RouteEnum.NOTIFY,
  component: LAYOUT,
  redirect: RouteEnum.NOTIFY_INDEX,
  meta: {
    hideChildrenInMenu: true,
    icon: 'ant-design:user-outlined',
    title: t('routes.notify.notify'),
    orderNo: 10,
    hideMenu: true,
  },
  children: [
    {
      path: 'index',
      name: RouteEnum.NOTIFY_INDEX,
      component: () => import('/@/layouts/default/header/components/notify/ListWrapper.vue'),
      meta: {
        title: '',
        hideMenu: true,
        hideBreadcrumb: false,
        currentActiveMenu: RouteEnum.NOTIFY_INDEX,
      },
    },
  ],
};

export default notify;
